export const useApi = () => {
  const instance = getCurrentInstance();

  const axios = instance?.appContext.config.globalProperties.$axios;

  const validationErrors = ref(null);

  const isLoading = ref(false);

  const fetchData = async (endpoint = "") => {
    isLoading.value = true;
    validationErrors.value = null;

    try {
      const response = await axios.get(endpoint);
      return response.data;
    } catch (error) {
      const err = useApiError(error);
      if (err.isValidationError) {
        Object.assign(validationErrors, err.bag);
      }
    } finally {
      isLoading.value = false;
    }
  };

  const postData = async (endpoint = "", payload = {}) => {
    isLoading.value = true;
    validationErrors.value = null;

    try {
      const response = await axios.post(endpoint, payload);
      return response.data;
    } catch (error) {
      const err = useApiError(error);
      if (err.isValidationError) {
        Object.assign(validationErrors, err.bag);
      }
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    validationErrors,
    isLoading,
    fetchData,
    postData,
  };
};
